<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5BDFjo/tc-custom/9781913618315.jpg?1729082774017" alt="This image is the cover for the book Palmistry, Ancient Wisdom for the New Age"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Palmistry, Ancient Wisdom for the New Age
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover how to see the future in your own two hands with this fully illustrated guide to palm reading.</b><br/>  <br/> For millennia, palmists and mediums have read the lines, bumps, shapes, and structure of hands to reveal hidden truths about people and their destinies. Interpreted correctly, they can tell us much about someone’s love, work, health, character traits, and skills.<br/>  <br/> This book describes the five main hand-types and their general significance. It features readings of the heart, head, and life lines, including examples of interpretations for each. With minutely detailed and labeled illustrations pointing out each curve and indentation, readers will learn to locate the mounts of the hand and recognize which determine one’s health, ambition, and nature.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Olga Lempiinska
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fox Chapel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d05f72c8